const variables = require('@/assets/style/_exported.module.scss')

export default variables.default || variables
